import { render, staticRenderFns } from "./weburlsetting.vue?vue&type=template&id=3991a4e6&scoped=true"
import script from "./weburlsetting.vue?vue&type=script&lang=js"
export * from "./weburlsetting.vue?vue&type=script&lang=js"
import style0 from "./weburlsetting.vue?vue&type=style&index=0&id=3991a4e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0___f047bfa682af2a89903e2d84cf35ffa3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3991a4e6",
  null
  
)

export default component.exports